export function registerSWListener(router) {
  if (!("serviceWorker" in navigator)) return;

  navigator.serviceWorker.addEventListener("message", (event) => {
    // 1. IMPORTANTE: El nombre del mensaje debe coincidir con el SW (OPEN_MODAL_PUSH)
    if (event.data?.type !== "OPEN_MODAL_PUSH") return;

    const { url, id } = event.data;

    // Usamos una configuración de cookie más permisiva para evitar fallos de dominio en dev
    const cookieOptions = "; path=/; max-age=600; SameSite=Lax";

    // console.log("SW Message recibido. URL:", url, "ID:", id);

    // 2. Guardamos cookies (Persistencia por si el router.push gatilla un logout o refresco)
    document.cookie = `rutaPush=${encodeURIComponent(url)}${cookieOptions}`;
    if (id) {
      document.cookie = `pushId=${id}${cookieOptions}`;
    }

    // 3. Lógica de Navegación Inteligente
    const currentPath = router.currentRoute.value.fullPath;

    if (currentPath !== url) {
      // Si la ruta es distinta, navegamos.
      // El onMounted de la vista destino (TareasView/Home) se encargará de abrir el modal.
      router.push(url).catch((err) => console.error("Error navegando:", err));
    } else {
      // Si YA estamos en la ruta, forzamos la apertura con el evento
      // console.log("Ya estamos en la ruta, disparando evento directo...");
      dispararEventoModal(url, id);
    }
  });
}

function dispararEventoModal(url, id) {
  if (!id) return;

  // Detectamos a qué bus de eventos enviar según la URL
  const eventName = url.includes("/tareas")
    ? "open-tarea-modal"
    : "open-tramite-modal";

  // console.log(`Emitiendo evento global: ${eventName} para ID: ${id}`);

  // Disparamos el evento personalizado que escuchan tus Vistas
  window.dispatchEvent(
    new CustomEvent(eventName, {
      detail: { id: id },
    }),
  );
}
